import { objectSerializer } from '@/libraries/composables/useStorage';

export function setStorageItem<T>(key: string, value: T): void {
    globalThis.localStorage.setItem(key, objectSerializer.encode(value));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getStorageItem<T = any>(key: string): T | null {
    const raw = globalThis.localStorage.getItem(key);
    if (!raw) return null;
    return objectSerializer.decode(raw);
}
